import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Heading, T } from "../components/helpful";
import noImg from "../assets/img/no-image.png";
import { getDestination } from "../api/api";
import { DestinationSkeleton } from "../components/skeleton";

/* The Mauritius class in JavaScript fetches destination data and renders it on a webpage, including
images, descriptions, and a map. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/

export default class Mauritius extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false, // Start as not loaded
      mainImg: null,
      about: "",
      descData: "",
      pageTitle: "",
      map: noImg,
      hotelImg: "",
      desc: "",
      fieldDescription: null,
      fielDescriptionData: {
        item_0: {
          title: "",
          image: noImg,
        },
        item_1: {
          title: "",
          image: noImg,
        },
        item_2: {
          title: "",
          image: noImg,
        },
        item_3: {
          title: "",
          image: noImg,
        },
        item_4: {
          title: "",
          image: noImg,
        },
        item_5: {
          title: "",
          image: noImg,
        },
      },
    };

    this.htmlContent = this.htmlContent.bind(this);
  }

  async componentDidMount() {
    let data = await getDestination();

    if (data) {
      this.setState(
        {
          mainImg: data[0]?.relationships.field_images_desktop.meta
            ?.imageDerivatives?.default_url
            ? data[0].relationships.field_images_desktop.meta.imageDerivatives
                .default_url
            : null,
          about: data[0]?.attributes.field_description_desktop
            ? data[0].attributes.field_description_desktop
            : "",
          descData: data[0]?.relationships.field_about_destination.data.meta
            ? data[0].relationships.field_about_destination.data.meta
            : "",
          pageTitle: data[0]?.attributes.title ? data[0].attributes.title : "",
          map: data[0]?.relationships?.field_about_destination?.data?.meta
            ?.field_map_desktop[0]?.imageDerivatives?.default_url
            ? data[0].relationships.field_about_destination.data.meta
                .field_map_desktop[0].imageDerivatives.default_url
            : noImg,
          hotelImg: "",
          desc: data[0]?.attributes.field_subtitle
            ? data[0].attributes.field_subtitle
            : "",
          fieldDescription: data[0]?.relationships.field_about_destination.data
            .meta.field_destination_detail
            ? data[0].relationships.field_about_destination.data.meta
                .field_destination_detail
            : "",
        },
        () => {
          if (this.state.fieldDescription) {
            this.setState({
              fielDescriptionData: {
                item_0: {
                  title: this.state.fieldDescription[0]?.description || "",
                  image: this.state.fieldDescription[0]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[0]?.image?.imageDerivatives
                        ?.default_url
                    : noImg,
                },
                item_1: {
                  title: this.state.fieldDescription[1]?.description || "",
                  image: this.state.fieldDescription[1]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[1]?.image.imageDerivatives
                        .default_url
                    : noImg,
                },
                item_2: {
                  title: this.state.fieldDescription[2]?.description || "",
                  image: this.state.fieldDescription[2]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[2]?.image.imageDerivatives
                        .default_url
                    : noImg,
                },
                item_3: {
                  title: this.state.fieldDescription[3]?.description || "",
                  image: this.state.fieldDescription[3]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[3]?.image.imageDerivatives
                        .default_url
                    : noImg,
                },
                item_4: {
                  title: this.state.fieldDescription[4]?.description || "",
                  image: this.state.fieldDescription[4]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[4]?.image.imageDerivatives
                        .default_url
                    : noImg,
                },
                item_5: {
                  title: this.state.fieldDescription[5]?.description || "",
                  image: this.state.fieldDescription[5]?.image?.imageDerivatives
                    ?.default_url
                    ? this.state.fieldDescription[5]?.image.imageDerivatives
                        .default_url
                    : noImg,
                },
              },
              isLoaded: true, // Set isLoaded to true after processing
            });
          }
        }
      );
    }
  }

  htmlContent = (html) => {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };
  subHeading = () => {
    return <>{this.state.desc}</>;
  };
  render() {
    return (
      <div>
        <div className="">
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          {this.state.isLoaded ? (
            <Row className="main-content">
              <Col sm="3">
                <img
                  src={this.state.mainImg}
                  className="img-fluid side-img mb-4"
                  alt="hotel-img"
                />
              </Col>
              <Col sm="9" className="">
                <div className="  ">{this.htmlContent(this.state.about)}</div>

                <div className="">
                  <h4 className="text-uppercase fs-6 mt-5 bcb-text-primary">
                    {this.state.descData.title}
                  </h4>
                </div>

                <div className="row mb-5">
                  <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <div className="row ">
                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_0"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className=" dest-text align-middle ">
                            <div className="">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_0"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_2"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className=" dest-text align-middle ">
                            <div className="">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_2"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination ">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_1"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className="dest-text align-middle">
                            <div className="">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_1"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination ">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_3"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className=" dest-text align-middle">
                            <div className="">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_3"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination ">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_4"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className=" dest-text align-middle">
                            <div className="mt-3">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_4"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="d-flex flex-row justify-content-start about-destination ">
                          <div className="">
                            <img
                              src={
                                this.state.fielDescriptionData["item_5"].image
                              }
                              alt="icon"
                              className=""
                            />
                          </div>
                          <div className=" dest-text align-middle">
                            <div className="mt-3">
                              {this.htmlContent(
                                this.state.fielDescriptionData["item_5"].title
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                    <img
                      src={this.state.map}
                      alt="world-map"
                      className="world-map"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <DestinationSkeleton />
          )}
        </div>
      </div>
    );
  }
}
